export default __webpack_public_path__ + "static/media/ic_djibouti.b0dad3b7.svg";